import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { FilterLabelWrapper } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/prompts-report/prompts-widget/PromptsComponent.styled";

export interface IMultiselectFilterOptionProps {
    label: string;
}

export const MultiselectFilterOption = ({ label }: IMultiselectFilterOptionProps) => (
    <Flex
        gap="8px"
        alignItems="center"
        overflow="hidden"
    >
        <FilterLabelWrapper title={label}>
            <Combobox.OptionLabel>{label}</Combobox.OptionLabel>
        </FilterLabelWrapper>
    </Flex>
);
